import React, { Component } from 'react';
import { DatePicker, AutoComplete, Button, Input, Select, message } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import SelectProvince  from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from "moment";
import SearchRetrieve from '../../common/SearchRetrieve.new';

const Option = Select.Option;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

// 校验value是否存在，且是options中的一项
function validateValueInOptions(value, name, list) {
    if (value) {
        const isExist = (list || []).some(item => item.value == value);
        if (!isExist) {
            message.warning(`请选择正确的${name}`);
            return true;
        }
    }
    return false;
}

class RecommendFilter extends Component {
    state = {
        areaList: [],
        diseaseList: [],
        searchParams: {},
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { searchParams } = this.state;
            const { trueYear: year, trueMonth } = res;
            const maxDate = `${year}-${trueMonth < 10 ? `0${trueMonth}` : trueMonth}`;
            searchParams.startDate = moment(maxDate).subtract(5, 'M').format(monthFormat);
            searchParams.endDate = maxDate;
            this.setState({ searchParams }, () => {
                this.loadAreaList();
            });
        });
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_SORT_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllInvestigationAreaSort}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { data = [] } = res;
            const { searchParams } = this.state;
            this.setState({
                searchParams: {
                    ...searchParams,
                    investigationAreaId: String(data[0].investigationAreaId)
                },
                areaList: data,
            },() => {
                this.search();
                this.loadDiseaseList();
            });
        });
    }

    loadDiseaseList = (search) => {
        const { searchParams: { investigationAreaId } } = this.state;
        const options = {
            method: 'POST',
            url: `${API_URL.common.queryAllDiseaseSort}`,
            data: {
                investigationAreaId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                const { searchParams } = this.state;
                if (search) {
                    const option = data.find(i => i.diseaseName == '非小细胞肺癌');
                    const { diseaseId, diseaseName } = option;
                    searchParams.diseaseId = diseaseId;
                    searchParams.diseaseName = diseaseName;
                }
                this.setState({
                    searchParams,
                    diseaseList: data,
                }, () => {
                    search && this.search();
                });
            }
        }
        $.sendRequest(options)
    }

    search = () => {
        const { searchParams } = this.state;
        const { areaParams } = searchParams;
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        const { siteStartBegin, siteStartEnd, startDate, endDate } = searchParams;
        if (key === 'siteStartBegin') {
            if (moment(dateString).valueOf() > moment(siteStartEnd).valueOf()) {
                message.warning('开始时间不能大于结束时间！');
                return;
            }
        } else if (key === 'siteStartEnd') {
            if (moment(dateString).valueOf() < moment(siteStartBegin).valueOf()) {
                message.warning('结束时间不能小于开始时间！');
                return;
            }
        } else if (key === 'startDate') {
            if (moment(dateString).valueOf() > moment(endDate).valueOf()) {
                message.warning('开始时间不能大于结束时间！');
                return;
            }
        } else if (key === 'endDate') {
            if (moment(dateString).valueOf() < moment(startDate).valueOf()) {
                message.warning('结束时间不能小于开始时间！');
                return;
            }
        }
        searchParams[key] = dateString
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'investigationAreaId') {
            searchParams.diseaseId = undefined;
            searchParams.diseaseName = '';
            this.setState({ searchParams }, () => {
                value ? this.loadDiseaseList() : this.setState({ diseaseList: [] });
            });
        } else {
            if(value instanceof  Array){
                let res = value.join(',');
                searchParams[key] = res;
            }
            this.setState({ searchParams });
        }
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleHighSearchInputChange = ( options, key, optionsName ) => {
        const { searchParams } = this.state;
        searchParams[`${key}Id`] = options.value;
        searchParams[`${key}Name`] = options.text;
        searchParams.hospitalId = undefined;
        this.setState({
            searchParams,
            [optionsName]: options,
        },() => this.queryCourtyardAreaList());
        
    }

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { searchParams: { hospitalMainId } } = this.state;
            if (hospitalMainId !== undefined ){
                const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    const needCourtyardArea = datas && datas[0].courtyardArea;
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                }
            };
            $.sendRequest(options);
            }
        }, 300);
    }

    handleAutoCompleteChange = (value, key) => {
        const { diseaseList, searchParams } = this.state;
        const option = (diseaseList || []).find(i => i.diseaseId == value) || {};
        const { diseaseId, diseaseName } = option;
        searchParams.diseaseId = diseaseId;
        searchParams.diseaseName = diseaseName || value;
        this.setState({ searchParams });
    }

    render() {
        const {
            areaList,
            diseaseList,
            searchParams,
            CourtyardAreaList,
            needCourtyardArea,
        } = this.state;
        const { siteStartBegin, siteStartEnd, startDate, endDate, areaName, hasCheckedArea = [], hospitalMainName, diseaseName, investigationAreaId } = searchParams;
        const areaOption = areaList.map(d => <Option key={String(d.investigationAreaId)}>{d.investigationAreaName}</Option>);
        const diseaseOption = diseaseList.map(d => <Option key={String(d.diseaseId)}>{d.diseaseName}</Option>);
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        return (
            <div className="search-bar" style={{marginBottom: 20}}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">中心启动时间</label>
                    <MonthPicker
                        placeholder="请选择"
                        format={monthFormat}
                        allowClear={true}
                        value={siteStartBegin ? moment(siteStartBegin) : null}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'siteStartBegin')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">至</label>
                    <MonthPicker
                        placeholder="请选择"
                        format={monthFormat}
                        allowClear={true}
                        value={siteStartEnd ? moment(siteStartEnd) : null}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'siteStartEnd')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">筛选入组时间</label>
                    <MonthPicker
                        placeholder="请选择"
                        format={monthFormat}
                        allowClear={false}
                        value={startDate ? moment(startDate) : null}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'startDate')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">至</label>
                    <MonthPicker
                        placeholder="请选择"
                        format={monthFormat}
                        allowClear={false}
                        value={endDate ? moment(endDate) : null}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endDate')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目领域</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        value={investigationAreaId || undefined}
                        onChange={value => this.handleSelectChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">疾病</label>
                    <AutoComplete
                        style={{ width: 150 }}
                        dataSource={diseaseOption}
                        placeholder="请输入"
                        value={diseaseName}
                        disabled={!investigationAreaId}
                        filterOption={(inputValue, option) => option.props.children.indexOf(inputValue) >= 0}
                        onChange={value => this.handleAutoCompleteChange(value, 'diseaseName')}
                        defaultActiveFirstOption={false}
                    >
                        <Input style={{ width: '100%' }} />
                    </AutoComplete>
                </div>
                <div className="search-item">
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="search-item">
                    <label className="ui-label">医院</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 200 }}
                        params={{ limit: 20 }}
                        placeholder="输入医院自动检索"
                        value={hospitalMainName}
                        url={API_URL.hospital.queryHospitalMainList}
                        config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                        onChange={options => this.handleHighSearchInputChange( options, 'hospitalMain', 'hospitalOptions')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">院区</label>
                    <Select
                            onSearch={this.queryCourtyardAreaList}
                            style={{ width: 220 }}
                            placeholder="请输入"
                            disabled={ !needCourtyardArea || !searchParams.hospitalMainId } 
                            onChange={ value => this.handleSelectChange(value, 'hospitalId')}
                            allowClear={true}
                            value={searchParams.hospitalId}
                        >
                            {CourtyardAreaOptions}
                        </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">是否可以SMO主导启动</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'isSmoLeader')}
                    >
                        <Option value='是'>是</Option>
                        <Option value='否'>否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">伦理前置</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'ethicalPre')}
                    >
                        <Option value='是'>是</Option>
                        <Option value='否'>否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">遗传办是否可以牵头</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'isGeneticOfficeCanLead')}
                    >
                        <Option value='是'>是</Option>
                        <Option value='否'>否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">科室综合推荐指数</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'recommendationIndexShow')}
                        multiple
                    >
                        <Option value='极力推荐'>极力推荐</Option>
                        <Option value='推荐'>推荐</Option>
                        <Option value='一般'>一般</Option>
                        <Option value='不推荐'>不推荐</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">该PI所在团队推荐指数</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'piRecommendationIndexShow')}
                        multiple
                    >
                        <Option value='极力推荐'>极力推荐</Option>
                        <Option value='推荐'>推荐</Option>
                        <Option value='一般'>一般</Option>
                        <Option value='不推荐'>不推荐</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">PI团队津石合作紧密程度</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'piCloseCooperationShow')}
                        multiple
                    >
                        <Option value='好'>好</Option>
                        <Option value='较好'>较好</Option>
                        <Option value='中'>中</Option>
                        <Option value='差'>差</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">SMO与CRO属于同一集团</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'smoAndCroSame')}
                        multiple
                    >
                        <Option value='不允许'>不允许</Option>
                        <Option value='可商量'>可商量</Option>
                        <Option value='无要求'>无要求</Option>
                        <Option value='其他'>其他</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">津石是否在准入（优选）名单里</label>
                    <Select
                        style={{ width: 100 }}
                        placeholder="请选择"
                        allowClear={true}
                        onChange={value => this.handleSelectChange(value, 'jinshiIsInPro')}
                    >
                        <Option value='是'>是</Option>
                        <Option value='否'>否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            </div>
        );
    }
}

class CompareFilter extends Component {
    state = {
        stageList: [],
        areaList: [],
        diseaseList: [],
        searchParams: {},
    }

    componentDidMount() {
        this.loadAreaList();
        this.loadTypeConfigureList();
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.typeConfigureList}`,
                data: {},
                dataType: 'json',
                doneResult: data => cb(data),
            });
        }, data => {
            this.setState({ stageList: data.stageList });
        });
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_SORT_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllInvestigationAreaSort}`,
                data: {},
                dataType: 'json',
                doneResult: data => cb(data),
            });
        }, data => {
            this.setState({ areaList: data.data });
        });
    }

    loadDiseaseList = investigationAreaId => {
        const options = {
            method: 'POST',
            url: `${API_URL.common.queryAllDiseaseSort}`,
            data: {
                investigationAreaId,
            },
            dataType: 'json',
            doneResult: data => {
                this.setState({ diseaseList: data.data });
            }
        }
        $.sendRequest(options)
    }

    search = () => {
        const { searchParams, sponsorOptions } = this.state;
        const { stageIds, investigationSponsorId } = searchParams;
        if (validateValueInOptions(investigationSponsorId, '申办方', sponsorOptions)) {
            return;
        }
        const params = {
            ...searchParams,
            stageIds: (stageIds || []).join(',')
        };
        this.props.search(params);
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'investigationAreaId') {
            searchParams.diseaseId = undefined;
        }
        this.setState({ searchParams }, () => {
            key === 'investigationAreaId' && value && this.loadDiseaseList(value);
        });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    showCompare = () => {
        this.props.showCompare();
    }

    render() {
        const {
            stageList,
            areaList,
            diseaseList,
            searchParams,
        } = this.state;
        const { stageIds, diseaseId, investigationAreaId } = searchParams;
        const stageOption = stageList.map(d => <Option key={String(d.typeConfigureId)}>{d.typeValue}</Option>);
        const areaOption = areaList.map(d => <Option key={String(d.investigationAreaId)}>{d.investigationAreaName}</Option>);
        const diseaseOption = diseaseList.map(d => <Option key={String(d.diseaseId)}>{d.diseaseName}</Option>);
        const { curRole } = sessionStorage;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目领域</label>
                    <Select
                        allowClear={true}
                        style={{ width: 100 }}
                        placeholder="请选择"
                        onChange={value => this.handleSelectChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">疾病</label>
                    <Select
                        allowClear={true}
                        style={{ width: 150 }}
                        placeholder="请选择"
                        value={diseaseId || undefined}
                        disabled={!investigationAreaId}
                        onChange={value => this.handleSelectChange(value, 'diseaseId')}
                    >
                        {diseaseOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目简称</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'investigationName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目名称</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'investigationSpecialName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目编号</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'investigationCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目阶段</label>
                    <Select
                        className="multiple-stage"
                        mode="multiple"
                        filterOption={false}
                        style={{ width: 150 }}
                        value={stageIds}
                        placeholder="请选择"
                        onChange={value => this.handleSelectChange(value, 'stageIds')}
                    >
                        {stageOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">申办方</label>
                    <HighSearchInput
                        keyword='customerCompanyName'
                        style={{ width: 162 }}
                        placeholder="输入名称检索"
                        params={{ limit: 20, natureName: '申办方' }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'investigationSponsorId', 'sponsorOptions')}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.showCompare}>中心比较</Button>
                    {
                        curRole != "CRC" && curRole != "CRCC" && curRole != "CRCM" &&
                        <Button type="primary" onClick={this.export}>导出</Button>
                    }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class RequireFilter extends Component {
    state = {
        searchParams: {},
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    search = () => {
        const { searchParams, userOptions, handUserOptions } = this.state;
        const { createUserId, handUserId } = searchParams;
        if (validateValueInOptions(createUserId, '发布人员', userOptions)) {
            return;
        }
        if (validateValueInOptions(handUserId, '处理人员', handUserOptions)) {
            return;
        }
        this.props.search(searchParams);
    }

    enterSearch = e => {
        if (e.charCode == 13) {
            this.search();
        }
    }

    showAdd = () =>{
        this.props.showAdd();
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        if (key === 'hospital'){
                searchParams[`${key}Name`] = value.text;
                searchParams[`${key}MainId`] = value.value;
                searchParams[`hospitalId`] = undefined;
                value.value && this.queryCourtyardAreaList();
        }else{
            searchParams[key] = value;
        }
        this.setState({ searchParams });
    }

    queryCourtyardAreaList = () => {
        const { searchParams: { hospitalMainId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalCourtyardAreaList,
            data: {    
                hospitalMainId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                const needCourtyardArea = datas && datas[0].courtyardArea;
                this.setState({ CourtyardAreaList: datas, needCourtyardArea });
            }
        };
        $.sendRequest(options);
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    render() {
        const { searchParams, CourtyardAreaList, needCourtyardArea } = this.state;
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">需求编号</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'siteJoinRequireCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">城市</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'hospitalCity')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">医院名称</label>
                    <SearchRetrieve
                        keyword="hospitalName"
                        style={{ width: 200 }}
                        placeholder="输入医院名称检索"
                        value={searchParams.hospitalName}
                        params={{ limit: 10, offset: 1 }}
                        url={API_URL.hospital.queryHospitalMainList}
                        config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                        onChange={value => this.handleSelectChange(value, 'hospital')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">院区</label>
                    <Select
                        allowClear={true}
                        style={{ width: 180 }}
                        placeholder="请选择"
                        disabled={ !needCourtyardArea || !searchParams.hospitalMainId } //本无院区，禁止填入；本有院区，且医院信息已填，允许填入
                        value={searchParams.hospitalId}
                        onChange={value => this.handleSelectChange(value, 'hospitalId')}
                    >
                        {CourtyardAreaOptions}
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">科室</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'departmentName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目意向（适应症）</label>
                    <Input
                        placeholder="请输入"
                        onChange={e => this.handleInputChange(e, 'investigationMalady')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">状态</label>
                    <Select
                        allowClear={true}
                        style={{width: 90}}
                        placeholder="请选择"
                        onChange={value => this.handleSelectChange(value, 'status')}
                    >
                        <Option value="HANDLED">处理</Option>
                        <Option value="UNHANDLE">未处理</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">发布人员</label>
                    <HighSearchInput
                        name='user'
                        keyword='keyword'
                        style={{ width: 140 }}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.team.userlist}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'createUserId', 'userOptions')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">处理人员</label>
                    <HighSearchInput
                        name='user'
                        keyword='keyword'
                        style={{ width: 140 }}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.team.userlist}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'handUserId', 'handUserOptions')}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.showAdd}>新建</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

export { RecommendFilter, CompareFilter, RequireFilter };



// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/Filter.js